import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

export const normalizeConditions = (group, dependencies) => {
  if (_isEmpty(group)) {
    return group;
  }
  // is single
  if (!group['@type']) {
    return {
      ...group,
      conditions: group.conditions.map(condition => {
        const { id, attributes } = dependencies[condition.field];

        return {
          ...condition,
          field: {
            name: attributes.name,
            id,
          },
        };
      }),
    };
  }

  // TODO: handle group condition case

  return group;
};

export const normalizeFields = (fields, dependencies) =>
  fields.map(field => {
    const { attributes, id } = dependencies[field];

    return {
      name: _get(attributes, 'name', ''),
      id,
    };
  });

export const convertMsecToSec = ms => (ms ? ms / 1000 : '');
